export const isGant = () => document.body.classList.contains("gant");
